//settings
import React, { useState, useEffect } from "react";

//styles
import StylesExperience from "./experience.module.scss";
import StylesGeneral from "../../structure_styles/general-styles.module.scss";

//assets
import pesH from "../../assets/experience_images/pesHidalgo.jpeg";
import pes from "../../assets/experience_images/pes.png";
import scio from "../../assets/experience_images/scio.jpeg";
import aspel from "../../assets/experience_images/aspel.png";
import tecnm from "../../assets/experience_images/tecnm.png";

//icons
import { 
    FaLaravel, FaReact, FaJs, FaPhp, FaCss3Alt, FaNodeJs, FaBootstrap, FaSass, 
    FaAws, FaHtml5, FaDocker
} from "react-icons/fa";
import { 
    SiMysql, SiTypescript, SiRubyonrails, SiJquery, SiAzuredevops, SiPhpmyadmin,
    SiPostgresql, SiAxios, SiPostman, SiClickup, SiXcode,
    SiCanva
} from "react-icons/si";
import { GiThreeLeaves } from "react-icons/gi";

const ExperienceView: React.FC = () => { 

    const [showExperience, setShowExperience] = useState(0);


    return (
        <>
            <div className={[StylesExperience.__main_exprience_container].join(' ')}>
                <div className={[StylesExperience.__show_experience].join(' ')}>
                    <div className={[StylesExperience.__experience_main_title].join(' ')}>
                            <div className={[StylesExperience.__title].join(' ')}>
                                Experiencia
                            </div>
                            <div className={[StylesExperience.__description].join(' ')}>
                                Desarrollador software con 3 años de experiencia en el ámbito profesional
                            </div>
                    </div>
                    <div className={[StylesExperience.__data_experience_container].join(' ')}>
                        <div className={[StylesExperience.__container].join(' ')}>
                            <div className={[StylesExperience.__body_container].join(' ')}>
                                <div className={[StylesExperience.__header_list].join(' ')}>
                                    <div onClick={()=>setShowExperience(0)} className={[StylesExperience.__experience_place].join(' ')}>
                                        <img src={pesH} alt="Pes H. logo" />
                                        <span>PES Hidalgo</span>
                                    </div>
                                    <div onClick={()=>setShowExperience(1)} className={[StylesExperience.__experience_place].join(' ')}>
                                        <img src={scio} alt="Scio logo" />
                                        <span>Scio</span>
                                    </div>
                                    <div onClick={()=>setShowExperience(2)} className={[StylesExperience.__experience_place].join(' ')}>
                                        <img src={aspel} alt="Aspel logo" />
                                        <span>Aspel S.</span>
                                    </div>
                                    <div onClick={()=>setShowExperience(3)} className={[StylesExperience.__experience_place].join(' ')}>
                                        <img src={pes} alt="Pes logo" />
                                        <span>PES</span>
                                    </div>
                                    <div onClick={()=>setShowExperience(4)} className={[StylesExperience.__experience_place].join(' ')}>
                                        <img src={tecnm} alt="TecNM logo" />
                                        <span>TecNM</span>
                                    </div>
                                </div>
                                {showExperience === 0 &&
                                    <div className={[StylesExperience.__experience_details].join(' ')}>
                                        <div className={[StylesExperience.__experience].join(' ')}>
                                            <div className={[StylesExperience.__business_name].join(' ')}>
                                                Partido Encuentro Solidario Hidalgo
                                            </div>
                                             <div className={[StylesExperience.__job].join(' ')}>
                                                <div className={[StylesExperience.__job_name].join(' ')}>
                                                    Desarrollador FullStack
                                                </div>
                                                <div className={[StylesExperience.__date].join(' ')}>
                                                    Ago 2024 - Actual
                                                </div>
                                                <div className={[StylesExperience.__project].join(' ')}>
                                                    <span className={[StylesExperience.__span].join(' ')}>
                                                        Proyecto: 
                                                    </span>
                                                    <span className={[StylesExperience.__name].join(' ')}>
                                                        Sistema para administración de afiliados en Hidalgo
                                                    </span>
                                                </div>
                                                <div className={[StylesExperience.__tech_list].join(' ')}>
                                                    <div className={[StylesExperience.__span].join(' ')}>
                                                        Tecnologias: 
                                                    </div>
                                                    <div className={[StylesExperience.__tech_list].join(' ')}>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <FaLaravel />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <FaJs />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <FaCss3Alt />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <SiAxios />
                                                        </div>
                                                        <div className={[StylesExperience.__icon, StylesExperience.__icon_small].join(' ')}>
                                                            <SiMysql />
                                                        </div>
                                                        <div className={[StylesExperience.__icon, StylesExperience.__icon_small].join(' ')}>
                                                            <SiPhpmyadmin />
                                                        </div>
                                                        <div className={[StylesExperience.__icon, StylesExperience.__icon_small].join(' ')}>
                                                            <SiCanva />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={[StylesExperience.__responsabilities].join(' ')}>
                                                    <div className={[StylesExperience.__span].join(' ')}>
                                                        Tareas principales
                                                    </div>
                                                    <div className={[StylesExperience.__responsabilities_list].join(' ')}>
                                                        <div>
                                                            - Desarrollar aplicación WEB para la administración de afiliados del partido (Fullstack).
                                                        </div>
                                                        <div>
                                                            - Solucionar bugs y proponer ideas de mejora.
                                                        </div>
                                                        <div>
                                                            - Administrar host y dominio (configurar https y hacer lanzamientos a producción).
                                                        </div>
                                                        <div>
                                                            - Modelado y creación de BD.
                                                        </div>
                                                        <div>
                                                            - Brindar soporte tecnico y dar mantenimiento al sitio WEB.
                                                        </div>
                                                        <div>
                                                            - Análisis de requerimientos.
                                                        </div>
                                                        <div>
                                                            - Contratación de servicios.
                                                        </div>
                                                        <div>
                                                            - Creación de contenido para redes sociales.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }

                                {showExperience === 1 &&
                                    <div className={[StylesExperience.__experience_details].join(' ')}>
                                        <div className={[StylesExperience.__experience].join(' ')}>
                                            <div className={[StylesExperience.__business_name].join(' ')}>
                                                Scio Consulting
                                            </div>
                                            <div className={[StylesExperience.__job].join(' ')}>
                                                <div className={[StylesExperience.__job_name].join(' ')}>
                                                    Desarrollador FullStack
                                                </div>
                                                <div className={[StylesExperience.__date].join(' ')}>
                                                    Nov 2023 - Mar 2024 ( 4 meses )
                                                </div>
                                                <div className={[StylesExperience.__project].join(' ')}>
                                                    <span className={[StylesExperience.__span].join(' ')}>
                                                        Proyecto: 
                                                    </span>
                                                    <span className={[StylesExperience.__name].join(' ')}>
                                                        Journey Time-off
                                                    </span>
                                                </div>
                                                <div className={[StylesExperience.__tech_list].join(' ')}>
                                                    <div className={[StylesExperience.__span].join(' ')}>
                                                        Tecnologias: 
                                                    </div>
                                                    <div className={[StylesExperience.__tech_list].join(' ')}>
                                                        <div className={[StylesExperience.__icon,  StylesExperience.__icon_small].join(' ')}>
                                                            <SiRubyonrails />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <SiJquery />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <SiPostgresql />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <SiAzuredevops />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={[StylesExperience.__responsabilities].join(' ')}>
                                                    <div className={[StylesExperience.__span].join(' ')}>
                                                        Tareas principales
                                                    </div>
                                                    <div className={[StylesExperience.__responsabilities_list].join(' ')}>
                                                        <div>
                                                            - Desarrollar nuevas funcionalidades y solucionar bugs.
                                                        </div>
                                                        <div>
                                                            - Participar en las todas las ceremonias Scrum, para planear y reportar avances.
                                                        </div>
                                                        <div>
                                                            - Configurar servidor para ambiente de calidad.
                                                        </div>
                                                        <div>
                                                            - Orientación técnica al líder de proyecto para mejor toma de decisiones
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={[StylesExperience.__job].join(' ')}>
                                                <div className={[StylesExperience.__job_name].join(' ')}>
                                                    Líder Técnico
                                                </div>
                                                <div className={[StylesExperience.__date].join(' ')}>
                                                    Mar 2023 - Nov 2023 ( 8 meses )
                                                </div>
                                                <div className={[StylesExperience.__project].join(' ')}>
                                                    <span className={[StylesExperience.__span].join(' ')}>
                                                        Proyecto: 
                                                    </span>
                                                    <span className={[StylesExperience.__name].join(' ')}>
                                                        InvoiScio
                                                    </span>
                                                </div>
                                                <div className={[StylesExperience.__tech_list].join(' ')}>
                                                    <div className={[StylesExperience.__span].join(' ')}>
                                                        Tecnologias: 
                                                    </div>
                                                    <div className={[StylesExperience.__tech_list].join(' ')}>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <FaReact />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <SiTypescript />
                                                        </div>
                                                        <div className={[StylesExperience.__icon,  StylesExperience.__icon_small].join(' ')}>
                                                            <FaBootstrap />
                                                        </div>
                                                        <div className={[StylesExperience.__icon,  StylesExperience.__icon_small].join(' ')}>
                                                            <FaSass />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <FaNodeJs />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <SiAxios />
                                                        </div>
                                                        <div className={[StylesExperience.__icon, StylesExperience.__icon_small].join(' ')}>
                                                            <SiMysql />
                                                        </div>
                                                        <div className={[StylesExperience.__icon, StylesExperience.__icon_small].join(' ')}>
                                                            <SiPhpmyadmin />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <SiClickup />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <FaAws />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <SiPostman />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={[StylesExperience.__responsabilities].join(' ')}>
                                                    <div className={[StylesExperience.__span].join(' ')}>
                                                        Tareas principales
                                                    </div>
                                                    <div className={[StylesExperience.__responsabilities_list].join(' ')}>
                                                        <div>
                                                            - Tomar requerimientos de aplicación y planear tecnologías y servicios necesarios.
                                                        </div>
                                                        <div>
                                                            - Planear cuestiones técnicas del proyecto y sincronizar con el equipo de IT (ambientes, credenciales, permisos, etc.).
                                                        </div>
                                                        <div>
                                                            - Modelado, implementación, manejo y administración de la BD.
                                                        </div>
                                                        <div>
                                                            - Desarrollar nuevas funcionalidades y solucionar bugs (frontend y backend).
                                                        </div>
                                                        <div>
                                                            - Participar en las todas las ceremonias Scrum, para planear y reportar avances.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={[StylesExperience.__job].join(' ')}>
                                                <div className={[StylesExperience.__job_name].join(' ')}>
                                                    Desarrollador FullStack
                                                </div>
                                                <div className={[StylesExperience.__date].join(' ')}>
                                                    Mar 2022 - Nov 2023 ( 1 año 8 meses )
                                                </div>
                                                <div className={[StylesExperience.__project].join(' ')}>
                                                    <span className={[StylesExperience.__span].join(' ')}>
                                                        Proyecto: 
                                                    </span>
                                                    <span className={[StylesExperience.__name].join(' ')}>
                                                        PidamosDe
                                                    </span>
                                                </div>
                                                <div className={[StylesExperience.__tech_list].join(' ')}>
                                                    <div className={[StylesExperience.__span].join(' ')}>
                                                        Tecnologias: 
                                                    </div>
                                                    <div className={[StylesExperience.__tech_list].join(' ')}>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <FaReact />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <SiTypescript />
                                                        </div>
                                                        <div className={[StylesExperience.__icon,  StylesExperience.__icon_small].join(' ')}>
                                                            <FaBootstrap />
                                                        </div>
                                                        <div className={[StylesExperience.__icon,  StylesExperience.__icon_small].join(' ')}>
                                                            <FaSass />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <FaLaravel />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <SiAxios />
                                                        </div>
                                                        <div className={[StylesExperience.__icon, StylesExperience.__icon_small].join(' ')}>
                                                            <SiMysql />
                                                        </div>
                                                        <div className={[StylesExperience.__icon, StylesExperience.__icon_small].join(' ')}>
                                                            <SiPhpmyadmin />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <SiClickup />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <FaAws />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <SiAzuredevops />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <FaDocker />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <SiXcode />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <SiPostman />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={[StylesExperience.__responsabilities].join(' ')}>
                                                    <div className={[StylesExperience.__span].join(' ')}>
                                                        Tareas principales
                                                    </div>
                                                    <div className={[StylesExperience.__responsabilities_list].join(' ')}>
                                                        <div>
                                                            - Desarrollar nuevas funcionalidades y solucionar bugs.
                                                        </div>
                                                        <div>
                                                            - Participar en las todas las ceremonias Scrum, para planear y reportar avances.
                                                        </div>
                                                        <div>
                                                            - Orientación técnica al líder de proyecto para mejor toma de decisiones.
                                                        </div>
                                                        <div>
                                                            - Apoyar y orientar al equipo de desarrollo.
                                                        </div>
                                                        <div>
                                                            - Sincronizar tareas DevOps con el departamento de IT.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }

                                {showExperience === 2 &&
                                    <div className={[StylesExperience.__experience_details].join(' ')}>
                                        <div className={[StylesExperience.__experience].join(' ')}>
                                            <div className={[StylesExperience.__business_name].join(' ')}>
                                                Aspel Simplementacion
                                            </div>
                                             <div className={[StylesExperience.__job].join(' ')}>
                                                <div className={[StylesExperience.__job_name].join(' ')}>
                                                    Programador Jr.
                                                </div>
                                                <div className={[StylesExperience.__date].join(' ')}>
                                                    Feb 2021 - Jul 2021 (5 meses)
                                                </div>
                                                <div className={[StylesExperience.__project].join(' ')}>
                                                    <span className={[StylesExperience.__span].join(' ')}>
                                                        Proyecto: 
                                                    </span>
                                                    <span className={[StylesExperience.__name].join(' ')}>
                                                        Sistema para administración de afiliados en Hidalgo
                                                    </span>
                                                </div>
                                                <div className={[StylesExperience.__tech_list].join(' ')}>
                                                    <div className={[StylesExperience.__span].join(' ')}>
                                                        Tecnologias: 
                                                    </div>
                                                    <div className={[StylesExperience.__tech_list].join(' ')}>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <FaHtml5 />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <FaCss3Alt />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <FaJs />
                                                        </div>
                                                        <div className={[StylesExperience.__icon, StylesExperience.__icon_small].join(' ')}>
                                                            <FaPhp />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <SiJquery />
                                                        </div>
                                                        <div className={[StylesExperience.__icon, StylesExperience.__icon_small].join(' ')}>
                                                            <SiMysql />
                                                        </div>
                                                        <div className={[StylesExperience.__icon, StylesExperience.__icon_small].join(' ')}>
                                                            <SiPhpmyadmin />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={[StylesExperience.__responsabilities].join(' ')}>
                                                    <div className={[StylesExperience.__span].join(' ')}>
                                                        Tareas principales
                                                    </div>
                                                    <div className={[StylesExperience.__responsabilities_list].join(' ')}>
                                                        <div>
                                                            - Tomar requerimientos necesarios.
                                                        </div>
                                                        <div>
                                                            - Desarrollar aplicación WEB personalizable.
                                                        </div>
                                                        <div>
                                                            - Desarrollar aplicación móvil personalizable usando B4X.
                                                        </div>
                                                        <div>
                                                            - Administrar host y dominio (configurar https y hacer lanzamientos a producción).
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }

                                {showExperience === 3 &&
                                    <div className={[StylesExperience.__experience_details].join(' ')}>
                                        <div className={[StylesExperience.__experience].join(' ')}>
                                            <div className={[StylesExperience.__business_name].join(' ')}>
                                                Partido Encuentro Solidario
                                            </div>
                                             <div className={[StylesExperience.__job].join(' ')}>
                                                <div className={[StylesExperience.__job_name].join(' ')}>
                                                    Desarrollador WEB FullStack
                                                </div>
                                                <div className={[StylesExperience.__date].join(' ')}>
                                                    Dic 2020 - Abr 2021 (4 meses)
                                                </div>
                                                <div className={[StylesExperience.__project].join(' ')}>
                                                    <span className={[StylesExperience.__span].join(' ')}>
                                                        Proyecto: 
                                                    </span>
                                                    <span className={[StylesExperience.__name].join(' ')}>
                                                        Sistema para control y administración de afiliados
                                                    </span>
                                                </div>
                                                <div className={[StylesExperience.__tech_list].join(' ')}>
                                                    <div className={[StylesExperience.__span].join(' ')}>
                                                        Tecnologias: 
                                                    </div>
                                                    <div className={[StylesExperience.__tech_list].join(' ')}>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <FaHtml5 />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <FaCss3Alt />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <FaJs />
                                                        </div>
                                                        <div className={[StylesExperience.__icon, StylesExperience.__icon_small].join(' ')}>
                                                            <FaPhp />
                                                        </div>
                                                        <div className={[StylesExperience.__icon].join(' ')}>
                                                            <SiJquery />
                                                        </div>
                                                        <div className={[StylesExperience.__icon, StylesExperience.__icon_small].join(' ')}>
                                                            <SiMysql />
                                                        </div>
                                                        <div className={[StylesExperience.__icon, StylesExperience.__icon_small].join(' ')}>
                                                            <SiPhpmyadmin />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={[StylesExperience.__responsabilities].join(' ')}>
                                                    <div className={[StylesExperience.__span].join(' ')}>
                                                        Tareas principales
                                                    </div>
                                                    <div className={[StylesExperience.__responsabilities_list].join(' ')}>
                                                        <div>
                                                            - Desarrollar aplicación WEB para la administración de afiliados del partido (Fullstack).
                                                        </div>
                                                        <div>
                                                            - Solucionar bugs y proponer ideas de mejora.
                                                        </div>
                                                        <div>
                                                            - Administrar host y dominio (configurar https y hacer lanzamientos a producción).
                                                        </div>
                                                        <div>
                                                            - Modelado y creación de BD.
                                                        </div>
                                                        <div>
                                                            - Brindar soporte tecnico y dar mantenimiento al sitio WEB.
                                                        </div>
                                                        <div>
                                                            - Análisis de requerimientos.
                                                        </div>
                                                        <div>
                                                            - Contratación de servicios.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }

                                {showExperience === 4 &&
                                    <div className={[StylesExperience.__experience_details].join(' ')}>
                                        <div className={[StylesExperience.__experience].join(' ')}>
                                            <div className={[StylesExperience.__business_name].join(' ')}>
                                                TecNM Campus Puruándiro
                                            </div>
                                            <div className={[StylesExperience.__job].join(' ')}>
                                                <div className={[StylesExperience.__job_name].join(' ')}>
                                                    Instructor
                                                </div>
                                                <div className={[StylesExperience.__date].join(' ')}>
                                                    Ago 2017 - Jun 2019 ( 1 año 10 meses )
                                                </div>
                                                <div className={[StylesExperience.__project].join(' ')}>
                                                    <span className={[StylesExperience.__span].join(' ')}>
                                                        Taller: 
                                                    </span>
                                                    <span className={[StylesExperience.__name].join(' ')}>
                                                        Lógica Matemática
                                                    </span>
                                                </div>
                                                <div className={[StylesExperience.__responsabilities].join(' ')}>
                                                    <div className={[StylesExperience.__span].join(' ')}>
                                                        Tareas principales
                                                    </div>
                                                    <div className={[StylesExperience.__responsabilities_list].join(' ')}>
                                                        <div>
                                                            - Apoyar a estudiantes de nivel superior a mejorar su razonamiento lógico
                                                            matemático, mediante actividades teórico practicas.
                                                        </div>
                                                        <div>
                                                            - Elaboración de plan de estudio y pruebas parciales.
                                                        </div>
                                                        <div>
                                                            - Reportar calificaciones al jefe de carrera y el departamento de vinculación.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={[StylesExperience.__job].join(' ')}>
                                                <div className={[StylesExperience.__job_name].join(' ')}>
                                                    Instructor
                                                </div>
                                                <div className={[StylesExperience.__date].join(' ')}>
                                                    Ago 2017 - Jun 2018 ( 10 meses )
                                                </div>
                                                <div className={[StylesExperience.__project].join(' ')}>
                                                    <span className={[StylesExperience.__span].join(' ')}>
                                                        Taller: 
                                                    </span>
                                                    <span className={[StylesExperience.__name].join(' ')}>
                                                        Programación
                                                    </span>
                                                </div>
                                                <div className={[StylesExperience.__responsabilities].join(' ')}>
                                                    <div className={[StylesExperience.__span].join(' ')}>
                                                        Tareas principales
                                                    </div>
                                                    <div className={[StylesExperience.__responsabilities_list].join(' ')}>
                                                        <div>
                                                            - Apoyar a estudiantes de nivel superior a mejorar su razonamiento lógico enfocado a la programacion, mediante actividades teórico practicas (JAVA y VB).
                                                        </div>
                                                        <div>
                                                            - Elaboración de plan de estudio y pruebas parciales.
                                                        </div>
                                                        <div>
                                                            - Reportar calificaciones al jefe de carrera y el departamento de vinculación.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                
                            </div>
                        </div>
                    </div>
               </div>
            </div>
        </>
    );
}

export default ExperienceView;